import React, { useState } from "react";
import styled from "styled-components";
import BackgroundImage from "../components/BackgroundImage";
import logoImg from "../assets/csir_logo.png";
import { Helmet } from "react-helmet";
// import Navbar from "../components/Navbar";
import background from "../assets/contactUs.webp";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organisation: "",
    title: "",
    message: "",
  });

  const [activeLink, setActiveLink] = useState('/');

    // ✅ Handle all input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handles submit via mailto (no backend)
  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, organisation, title, message } = formData;

    if (!name || !email || !organisation || !title || !message) {
      alert("Please fill in all required fields.");
      return;
    }

    const subject = encodeURIComponent(title);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nOrganisation: ${organisation}\n\nMessage:\n${message}`
    );

    // Opens the user's email client with prefilled data
    window.location.href = `mailto: solaraiddsupport@csir.co.za?subject=${subject}&body=${body}`;
  };
  return (
    <>
      {/* <GlobalStyle /> */}
      <PageContainer>
        <Helmet>
          <title>Contact Us | SolarAIDD</title>
          <meta name="description" content="Get in touch with the SolarAIDD team at CSIR for technical support, partnerships, or inquiries regarding our AI solar PV analysis platform."/>
          <meta name="keywords" content="AI defect detection, solar PV EL, solar image analysis, module defects, cell defects, batch inspection" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://solaraidd.csir.co.za/contactUs" />
        </Helmet>
        
        {/* Navigation Bar */}
      
        <Navbar>
          <BrandContainer onClick={() => navigate('/')}>
            <Logo src={logoImg} alt="Logo" />
            <Brand>SolarAIDD</Brand>
          </BrandContainer>
          <NavLinks>
            <NavLink isActive ={activeLink ==='/'} onClick={() =>{navigate('/'); setActiveLink('/login')}}>Home</NavLink>
            <NavLink isActive={activeLink ==='/login'} onClick={() => navigate('/login')}>Login</NavLink>
            <NeonButton as="a" href="https://outlook.office.com/book/SolarAIDD@csir.co.za/" target="_blank" rel="noopener noreferrer">Book A Demo</NeonButton>
          </NavLinks>
        </Navbar>
        
        <HeroSection>
          <HeroTextWrapper>
            <HeroSubLabel>CONTACT US</HeroSubLabel>
            <HeroTitle>Got Questions?</HeroTitle>
            <HeroSubtitle>
              You have questions, we have answers. Contact us to discuss your business goals.
            </HeroSubtitle>
          </HeroTextWrapper>
        </HeroSection>
        
        <ContentSection>
          <LeftContent>
                
          </LeftContent>
        
          <RightFormCard>
            <FormHeader>Let's Connect</FormHeader>
            <Form onSubmit={handleSubmit}>
              <Label>Name: *</Label>
              <Input
                name="name"
                placeholder="Full Name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <Label>Email: *</Label>
              <Input
                name="email"
                placeholder="Email Address"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <Label>Organisation: *</Label>
              <Input
                name="organisation"
                placeholder="Company Name"
                type="text"
                value={formData.organisation}
                onChange={handleChange}
                required
              />

              <Label>Subject: *</Label>
              <Input
                name="title"
                type="text"
                value={formData.title}
                onChange={handleChange}
                required
              />

              <Label>How can we help? *</Label>
              <TextArea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />

              <SubmitButton type="submit">Send Message</SubmitButton>
            </Form>
          </RightFormCard>
        </ContentSection>
      </PageContainer>
    </>
  )
}

export default ContactUs;

// Page layout
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e9edf0ff 0%, #dee5e9ff 60%, #edf3f8ff 100%);
  min-height: 100vh;
`;

// Navigation Bar Styling (Responsive)

const Navbar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color:#293439; 
  color: white;
  z-index: 3; // Stay above all other elements
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.0);
`;

// Brand/Logo Text Styling
const BrandContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

const Brand = styled.div`
  font-size: 1.5rem;
  font-weight: bold;

  // Media query for smaller screens
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
;
`;

const Logo = styled.img`
    width: 133px;
    height: 45px;
    margin-right: 0.5rem;
`;
  
// Navigation Links Container
const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  transition: color 0.3s;

  &:hover {
    color: cyan;
  }

  &.active {
    color: cyan;
  }

  // Media query for smaller screens
  @media (max-width: 768px) {
    flex-direction: column; // Stack links vertically
    gap: 0.5rem; // Reduce spacing between links
    width: 100%;
    align-items: center; // Center the links on smaller screens
  }
`;

// Link Styling
const NavLink = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #E55B41;
    }

    // Media query for smaller screens
    @media (max-width: 768px) {
        font-size: 1rem;
        padding: 0.5rem;
    }
    ;
`;

const NeonButton = styled.button`
  padding: 0.6rem 1.4rem;
  font-size: 1rem;
  color: #0ff;
  background: transparent;
  border: 2px solid #0ff;
  border-radius: 30px;
  cursor: pointer;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px #0ff, 0 0 10px #0ff;
  text-decoration: none;

  &:hover {
    background: #0ff;
    color: #000;
    box-shadow: 0 0 10px #0ff, 0 0 20px #0ff, 0 0 30px #0ff;
  }

  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    z-index: -1;
    background: linear-gradient(90deg, #0ff, #00f, #0ff);
    background-size: 400%;
    border-radius: 30px;
    animation: glowMove 4s linear infinite;
    opacity: 0.4;
  }

  @keyframes glowMove {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 400% 50%;
    }
  }
`;

const HeroSection = styled.section`
  background: linear-gradient(to right, #2A3439 40%, #2A3439 100%);
  padding: 6rem 2rem 10rem 2rem;
  color: white;
  text-align: left;
  display: flex;
  justify-content: center;
`;

const HeroTextWrapper = styled.div`
  max-width: 1100px;
  width: 100%;
`;

const HeroSubLabel = styled.div`
  text-transform: uppercase;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 1px;
  opacity: 0.9;
`;

const HeroTitle = styled.h1`
  font-size: 2.8rem;
  margin: 0.5rem 0 1rem;
`;

const HeroSubtitle = styled.p`
  font-size: 1.05rem;
  line-height: 1.6;
  color: #f0f0f0;
  max-width: 600px;
`;

const ContentSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 0 2rem 4rem;
  margin-top: -20rem;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0;
    padding-top: 2rem;
    align-items: center;
  }
`;

const LeftContent = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  padding: 1.5rem;
  color: grey;

  h3 {
    margin-top: 1000px;
    font-size: 1.2rem;
    font-weight: bold;
  }

  ul {
    padding-left: 1.2rem;
    margin: 1rem 0;
  }

  li {
    margin-bottom: 0.5rem;
    line-height: 1.5;
  }

  p {
    margin: 0.5rem 0;
  }
`;

const RightFormCard = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 500px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  color: white;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.65);
  padding: 2rem;
  margin-left: 200px;
  align-self: flex-start;

  @media (max-width: 768px) {
    align-self: center;
  }
`;

const FormHeader = styled.div`
  background: rgba(255, 255, 255, 0.1);
  color: white;
  padding: 1rem 2rem;
  border-radius: 12px 12px 0 0;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  margin: -2rem -2rem 1rem -2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  color: #000;
`;

const Label = styled.label`
  font-weight: bold;
  margin-top: 1rem;
  color: #e36c0a;
`;

const Input = styled.input`
  padding: 0.7rem;
  border: none;
  border-bottom: 2px solid #ccc;
  margin-top: 0.2rem;
  color: #000;
  background: #dde6eaff;
  &:focus {
    border-bottom: 2px solid orange;
    outline: none;
  }
`;

const TextArea = styled.textarea`
  padding: 0.7rem;
  border: 2px solid #ccc;
  border-radius: 5px;
  min-height: 100px;
  margin-top: 0.2rem;
  color: #000;
  background: #dde6eaff;
  &:focus {
    border-bottom: 2px solid orange;
    outline: none;
  }
`;

const SubmitButton = styled.button`
  margin-top: 2rem;
  padding: 0.9rem;
  background-color: orange;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
  &:hover {
    background-color: #e36c0a;
  }
`;

